module.exports = __webpack_public_path__ + "img/twitter.86e11007.svg";